module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f604.626aaed4.svg";